export enum WesterosNoteTypeModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
